import { AuthenticationService } from '../_services';

export function HandleResponse(response) {
    debugger
        const data = response && response.data;
        if (response.statusText == "Ok") {
            if ([401, 403].indexOf(response.status) !== -1) {
                // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                AuthenticationService.logout();
                
                // Set flag to prevent auto-login after logout
                sessionStorage.setItem('just_logged_out', 'true');
                
                // Navigate to login page instead of reloading
                window.location.href = '/authentication/Login';
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    
}